import { h } from '@stencil/core';
import { i18n } from 'i18n';
import tripPlanner from 'store/tripPlanner';
import { triggerSubmitChatMessage, triggerTrackEvent } from 'utils/events';

export default function EditTextModal({ show }: { show: boolean }) {
  const MAX_LENGTH = 300;

  const getPrefix = (fieldIndex: number) => {
    const field = tripPlanner.fields![fieldIndex];
    switch (field.type) {
      case 'TRIP_TITLE':
        return i18n.t.editTextModal.prefix.tripTitle;
      case 'TRIP_DAY_TITLE':
        return i18n.t.editTextModal.prefix.tripDayTitle(field.index!);
      case 'TRIP_DAY_DESCRIPTION':
        return i18n.t.editTextModal.prefix.tripDayDescription(field.index!, field.location);
    }
  };

  const onClose = () => {
    triggerTrackEvent({
      event_type: 'user',
      event_name: `edit_text_close`,
    });
    tripPlanner.showModal = null;
  };

  const onSend = () => {
    triggerTrackEvent({
      event_type: 'user',
      event_name: `edit_text_send`,
      data: {},
    });

    const messageToSend = tripPlanner
      .fields!.filter(field => field.textToEdit !== field.initialText)
      .map((field, index) => getPrefix(index).concat(' ', field.textToEdit))
      .map(text => text.trim())
      .join('\n');

    if (!messageToSend) {
      onClose();
    } else {
      triggerSubmitChatMessage({
        message: messageToSend,
        type: 'USER',
        from: 'BACKEND',
        method: 'TEXT',
      });

      onClose();
    }
  };

  return show ? (
    <div id="edit-text-modal" role="presentation" class="eva-3-modal -show-sticky-footer -smooth-scroll fullscreen-modal -border-bottom -close-on-left -show-modal">
      <div class="modal-header" role="presentation">
        <div class="modal-title-container">
          <h4 class="eva-3-h4 modal-title">{i18n.t.editTextModal.title}</h4>
        </div>
        <i class="eva-3-icon-cross modal-close -eva-3-mr-md -eva-3-hide-small" role="button" tabindex="0" aria-label={i18n.t.editTextModal.close} onClick={onClose}></i>
        <i class="eva-3-icon-arrow-bold-left modal-close -eva-3-hide-medium-up" role="button" tabindex="0" aria-label={i18n.t.editTextModal.close} onClick={onClose}></i>
      </div>
      <div class="modal-content" role="presentation">
        {tripPlanner.fields!.map(field => (
          <div class="field-container" style={{ paddingBottom: '16px' }}>
            <div class="eva-3-textarea -lg">
              <div class="textarea-container">
                <textarea
                  class="textarea-tag"
                  value={field.textToEdit}
                  onKeyUp={event => {
                    field.textToEdit = (event.target as HTMLTextAreaElement).value;
                  }}
                  rows={4}
                  data-twofas-input-listener="true"
                  maxlength={MAX_LENGTH}
                ></textarea>
              </div>
              <span class="textarea-message">{i18n.t.chat.textarea.remaining(MAX_LENGTH - field.textToEdit.length, MAX_LENGTH)}</span>
            </div>
          </div>
        ))}
      </div>
      <div class="modal-footer">
        <button type="button" class="eva-3-btn -lg -primary" onClick={onSend}>
          <em class="btn-text">{i18n.t.editTextModal.send}</em>
        </button>
      </div>
    </div>
  ) : null;
}
